import { OffsiteSimilarDesignsSection } from '@app/pages/i/components/OffsiteSimilarDesignsSection/OffsiteSimilarDesignsSection';
import { useSimilarDesignsContext } from '@app/pages/i/utils/SimilarDesignsContext';
import { Box } from '@redbubble/design-system';
import React from 'react';
import styles from './OffsiteSimilarDesignsContainer.module.scss';

const OffsiteSimilarDesignsContainer: React.FC = () => {
  const {
    similarDesignsData,
    similarDesignsLoading,
    showOffsiteSimilarDesignsSection,
    refreshSimilarDesigns,
  } = useSimilarDesignsContext();

  if (!showOffsiteSimilarDesignsSection) {
    return null;
  }
  return (
    <Box className={styles.offsiteSimilarDesignsSection}>
      <OffsiteSimilarDesignsSection
        similarDesignsLoading={similarDesignsLoading}
        similarDesigns={similarDesignsData.offsiteSimilarDesigns}
        refreshSimilarDesigns={refreshSimilarDesigns}
      />
    </Box>
  );
};

export default OffsiteSimilarDesignsContainer;
